import { Image } from "@heroui/image";
import { Link } from "@heroui/link";
import { FaYoutube, FaFacebook, FaTwitter, FaInstagram } from "react-icons/fa";

// Footer navigation links - specific to the landing page sections
const links = [
  { href: "/", name: "Home" },
  { href: "/", name: "Explore" },
  { href: "/", name: "About" },
  { href: "/", name: "Menu" },
  { href: "/", name: "Contact" },
] as const;

// Social media icon components
const socialIcons = [
  { icon: <FaYoutube />, href: "/" },
  { icon: <FaFacebook />, href: "/" },
  { icon: <FaTwitter />, href: "/" },
  { icon: <FaInstagram />, href: "/" },
];

const Footer = () => {
  return (
    // Footer with background image (bg-footer from tailwind config)
    // relative: For positioning the overlay
    <footer
      className="bg-footer bg-cover bg-no-repeat pt-16 relative"
      id="contact"
    >
      {/* Dark Overlay - 90% opacity black overlay for text readability */}
      <div className="absolute w-full h-full bg-black/90 z-10 top-0 left-0" />

      {/* Content Container - z-20 to sit on top of overlay */}
      <div className="container mx-auto z-20 relative">
        <div className="flex flex-col items-center justify-center gap-14">
          {/* Footer Logo */}
          <Link
            className="relative w-30 h-12.5 mx-auto overflow-hidden"
            href="#home"
            onClick={(e) => {
              e.preventDefault();
              document
                .getElementById("home")
                ?.scrollIntoView({ behavior: "smooth" });
            }}
          >
            <Image
              removeWrapper // HeroUI Image wrapper can sometimes interfere with sizing in flex containers
              alt="Zenbrew Logo"
              className="object-contain w-full h-full"
              src="/assets/logo.webp"
            />
          </Link>

          {/* Footer Navigation Links - Vertical on mobile, horizontal on xl */}
          <nav className="flex flex-col xl:flex-row gap-8 xl:gap-12 justify-center items-center">
            {links.map((link, index) => (
              <Link
                key={index}
                className="uppercase text-white tracking-widest hover:text-accent transition-all text-base font-semibold"
                href={`#${link.name.toLowerCase() === "explore" ? "benefits" : link.name.toLowerCase()}`}
                onClick={(e) => {
                  e.preventDefault();
                  const id =
                    link.name.toLowerCase() === "explore"
                      ? "benefits"
                      : link.name.toLowerCase();

                  document
                    .getElementById(id)
                    ?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* Social Media Icons - Circular buttons with border */}
          <ul className="flex text-white text-xl gap-4">
            {socialIcons.map((social, index) => (
              <Link
                key={`social-${index}`}
                className="w-10 md:w-14 h-10 md:h-14 border text-white border-white/15 rounded-full flex items-center justify-center hover:text-accent transition-all hover:border-accent"
                href={social.href}
              >
                {social.icon}
              </Link>
            ))}
          </ul>

          {/* Copyright Notice */}
          <div className="border-t border-white/10 text-[15px] text-white/70 font-light w-full flex items-center justify-center py-6">
            <p>
              &copy; Copyright {new Date().getFullYear()} - Coffee shop. All
              rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
